export enum KeywordMasterListAction {
  ADD = "add",
  REMOVE = "remove"
}